import { NavigateToV1 } from '@/domain/mitarbeiter/pages/rotationsplan/NavigateToV1';
import { useProfile } from '@/hooks';
import { ReactNode, useLayoutEffect } from 'react';

// Experiment: Brand-Farbe im Rotationsplan auf Rot statt Blau. Die v2-Tokens
// `brand-red-*` zeigen auf `--color-primary-blue-500/600`, daher werden diese
// beiden Variablen überschrieben. Am Root gesetzt, damit auch Dialoge, Drawer
// und Popover (Portale in `body`) die Farbe übernehmen.
const BRAND_RED_OVERRIDES = {
  '--color-primary-blue-500': '#fe4d4c',
  '--color-primary-blue-600': '#fc3736',
};

function useBrandRedExperiment() {
  useLayoutEffect(() => {
    const { style } = document.documentElement;
    Object.entries(BRAND_RED_OVERRIDES).forEach(([name, value]) =>
      style.setProperty(name, value),
    );
    return () => {
      Object.keys(BRAND_RED_OVERRIDES).forEach((name) =>
        style.removeProperty(name),
      );
    };
  }, []);
}

export function WithRotationsplanBenutzerrecht({
  children,
}: {
  children: ReactNode;
}) {
  const { manager } = useProfile();
  const hasRotationsplanRecht = manager?.rechte.mitarbeiter.rotationsplan;
  useBrandRedExperiment();

  if (!hasRotationsplanRecht) {
    return <NavigateToV1 />;
  }

  return children;
}
